// Re-Export-Hygiene: explizite Named-Imports/-Exports statt `export *`,
// damit Vite/Rollup beim SSR-Build kein "Ambiguous external namespace
// resolution" mehr meldet (mehrdeutige Re-Exports zwischen den
// three/examples/jsm-Modulen).
//
// FBX/GLTF/OBJLoader werden seit M2 (Plan-1.9-Phase-1-CP2) NICHT mehr
// statisch importiert. Sie werden von updateObject() in RendererWebGL.ts
// via dynamic import nur dann geladen, wenn ein object3d-Layer mit der
// entsprechenden extension instanziiert wird.

import * as three from 'three'

import { DDSLoader } from 'three/examples/jsm/loaders/DDSLoader.js'

import { CSS3DObject, CSS3DRenderer } from 'three/examples/jsm/renderers/CSS3DRenderer.js'
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// Port "3D-Text": laedt die Typeface-JSON fuer text3d/number3d-Primitive.
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
// Port "HDRI": Radiance-.hdr (RGBE) + OpenEXR-Decoder fuer Image-Based-Lighting.
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js'
// Port "Primitive": RoundedBox-Geometrie + Geometrie-Merge fuer die Builder.
import { RoundedBoxGeometry } from 'three/examples/jsm/geometries/RoundedBoxGeometry.js'
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js'
// Port "Mirrors" Teil B: planarer Spiegel (rendert die echte Szene ueber die Ebene).
import { Reflector } from 'three/examples/jsm/objects/Reflector.js'
// Cutover Schritt 2b: Transform-Gizmo (Achsen-Handles fuer den ausgewaehlten Layer).
import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js'

export {
  CSS3DObject,
  CSS3DRenderer,
  SVGLoader,
  OrbitControls,
  FontLoader,
  RGBELoader,
  EXRLoader,
  RoundedBoxGeometry,
  mergeGeometries,
  Reflector,
  TransformControls,
}

new three.LoadingManager().addHandler(/\.dds$/i, new DDSLoader())

export default three
